webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default.a, {
  preLoad: 1.1,
  attempt: 1
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Images_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Images_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Images_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue___default.a,
    Images: __WEBPACK_IMPORTED_MODULE_1__components_Images_vue___default.a
  },
  data: function data() {
    return {
      menu: false,
      load: false

    };
  },

  created: function created() {
    this.load = true;
  },
  methods: {
    togglePanel: function togglePanel() {
      this.menu = !this.menu;
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'images',
  data: function data() {
    return {
      thefrontend: {
        url: 'https://thefrontend.uk'
      },
      images: 'loading'
    };
  },

  methods: {
    getImage: function getImage(path) {
      return this.thefrontend.url + path;
    },
    getResponsiveImage: function getResponsiveImage(path) {
      if (window.innerWidth > 768) {
        return this.thefrontend.url + path.lg;
      } else if (window.innerWidth > 480 && window.innerWidth <= 768) {
        return this.thefrontend.url + path.sm;
      } else {
        return this.thefrontend.url + path.xs;
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get('https://thefrontend.uk/wp-json/wp/v2/northerntake/?per_page=100').then(function (response) {
      _this.images = response.data;
    }).catch(function () {
      _this.images = false;
    });
  }

});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  data: function data() {
    return {
      panel: false,
      menu: false
    };
  },

  methods: {
    togglePanel: function togglePanel(panel) {
      var menu = this.menu;
      if (this.panel === panel && !this.menu) {
        this.panel = panel;
        this.menu = true;
      } else {
        this.menu = this.panel === panel ? this.menu = false : this.menu = true;
        this.panel = panel;
      }

      if (menu !== this.menu) {
        this.$emit('menu');
      }
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI2NHB4IiBoZWlnaHQ9IjY0cHgiIHZpZXdCb3g9IjAgMCA2NCA2NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjQgNjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGc+Cgk8Zz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMzEuOSwwYzksMCwxNi42LDMuMSwyMi43LDkuM0M2MC45LDE1LjUsNjQsMjMsNjQsMzJzLTMsMTYuNS05LjEsMjIuNWMtNi41LDYuMy0xNC4yLDkuNS0yMyw5LjUKCQkJYy04LjYsMC0xNi4yLTMuMS0yMi41LTkuNFMwLDQwLjgsMCwzMlMzLjEsMTUuNyw5LjQsOS4zQzE1LjYsMy4xLDIzLjEsMCwzMS45LDB6IE0zMi4xLDUuOGMtNy4zLDAtMTMuNCwyLjYtMTguNSw3LjcKCQkJQzguNCwxOC44LDUuOCwyNSw1LjgsMzJjMCw3LjEsMi42LDEzLjIsNy44LDE4LjRzMTEuNCw3LjgsMTguNSw3LjhzMTMuMy0yLjYsMTguNi03LjhjNS00LjgsNy41LTExLDcuNS0xOC4zcy0yLjYtMTMuNS03LjctMTguNgoJCQlDNDUuNSw4LjMsMzkuMyw1LjgsMzIuMSw1Ljh6IE00MC42LDI0LjF2MTMuMUgzN3YxNS41SDI3VjM3LjFoLTMuN3YtMTNjMC0wLjYsMC4yLTEuMSwwLjYtMS41czAuOS0wLjYsMS41LTAuNmgxMy4xCgkJCWMwLjUsMCwxLDAuMiwxLjQsMC42QzQwLjQsMjMsNDAuNiwyMy41LDQwLjYsMjQuMXogTTI3LjUsMTUuOGMwLTMsMS41LTQuNSw0LjUtNC41czQuNSwxLjUsNC41LDQuNVMzNSwyMC4zLDMyLDIwLjMKCQkJUzI3LjUsMTguOCwyNy41LDE1Ljh6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(34)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(43),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2439fd08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [(_vm.images === 'loading') ? _c('div', {
    staticClass: "loader"
  }) : (_vm.images === false) ? _c('div', {
    staticClass: "error-msg"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_vm._v("\n      It seems there are no images to display.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Please check your internet connection.\n    ")])]) : _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "image"
    }, [_c('a', {
      staticClass: "image__wrap",
      attrs: {
        "href": _vm.getImage(image.acf.image.url),
        "title": image.title.rendered,
        "target": "_blank"
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.getResponsiveImage(image.acf.image.sizes)),
        expression: "getResponsiveImage(image.acf.image.sizes)"
      }],
      attrs: {
        "alt": image.title.rendered
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "image__download",
      attrs: {
        "href": _vm.getImage(image.acf.image.url)
      }
    }, [_c('span', {
      staticClass: "icon-download",
      attrs: {
        "target": "_blank"
      }
    }), _vm._v(" Download")])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "load-overlay",
    class: {
      loaded: _vm.load
    }
  }), _vm._v(" "), _c('sidebar', {
    on: {
      "menu": function($event) {
        _vm.togglePanel()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('images', {
    class: {
      menuOpen: _vm.menu
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header--main"
  }, [_c('h2', [_c('b', [_vm._v("Free Photos")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://thefrontend.uk",
      "target": "_blank"
    }
  }, [_vm._v("Alex Shepherd")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(40),
      "alt": "Creative Commons",
      "width": "32px",
      "height": "32px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(39),
      "alt": "Creative Commons",
      "width": "32px",
      "height": "32px"
    }
  })])
}]}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    staticClass: "sidebar__menu"
  }, [_c('transition', [(_vm.panel === 'tags') ? _c('div', {
    key: "tags",
    staticClass: "sidebar__panel--tags inner"
  }, [_c('button', {
    staticClass: "btn--close--white",
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.panel)
      }
    }
  }, [_c('span', {
    staticClass: "icon-tick"
  }), _vm._v(" Done")])]) : (_vm.panel === 'contact') ? _c('div', {
    key: "contact",
    staticClass: "sidebar__panel--contact inner"
  }, [_c('button', {
    staticClass: "btn--close--white",
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.panel)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  }), _vm._v(" Close")])]) : (_vm.panel === 'info') ? _c('div', {
    key: "info",
    staticClass: "sidebar__panel--info inner"
  }, [_c('button', {
    staticClass: "btn--close--white",
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.panel)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  }), _vm._v(" Close")])]) : _vm._e()])], 1)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar__nav"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_vm._v("\n        Northern Take\n      ")]), _vm._v(" "), _c('nav', {
    staticClass: "nav--main"
  }, [_c('ul')])])
}]}

/***/ })
],[30]);


// WEBPACK FOOTER //
// static/js/app.bbeb9c651050e04bf2eb.js